'use client';

import { amazonColors } from '../../constants/colors';

import { isNil } from 'es-toolkit';
import { formatCurrency } from '@skin-seoul/service';
import type { Currency } from '@skin-seoul/service';
import TicketIcon from './TicketIcon';

interface PriceOnAmazonProps {
  price: string | number;
  currency: Currency;
}

export const PriceOnAmazon = ({ price, currency }: PriceOnAmazonProps) => {
  return (
    <div
      className="flex items-center justify-center w-full h-fit pt-5 pb-2"
      style={{ background: 'linear-gradient(180deg, rgba(5, 120, 255, 0) 0%, rgba(5, 120, 255, 0.4) 100%)' }}
    >
      <div className="flex flex-row gap-1 tablet:gap-2 items-center h-full">
        <div className="w-5 h-5 flex items-center justify-center max-[420px]:hidden">
          <TicketIcon />
        </div>
        {isNil(price) ? (
          <span className="text-label-xsmall tablet:text-label-small font-normal text-[#232F3E] whitespace-nowrap">
            Wow-Level Price
          </span>
        ) : (
          <>
            <span className="text-label-xsmall tablet:text-label-small font-normal text-[#232F3E] whitespace-nowrap">
              Price On Amazon
            </span>

            <div
              className="h-5 rounded-[6px] flex items-center justify-center px-1"
              style={{ backgroundColor: amazonColors.prime.blue }}
            >
              <span
                className="text-label-xsmall tablet:text-label-small font-semibold whitespace-nowrap"
                style={{ color: amazonColors.prime.yellow }}
              >
                {formatCurrency(currency, price)}
              </span>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default PriceOnAmazon;
